import { render, staticRenderFns } from "./MessagePreviewCall.vue?vue&type=template&id=0b280e5b&"
import script from "./MessagePreviewCall.vue?vue&type=script&lang=ts&"
export * from "./MessagePreviewCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports